__turbopack_context__.v({
  "copyright_section": "styles-module-scss-module__oviM2W__copyright_section",
  "directions_label": "styles-module-scss-module__oviM2W__directions_label",
  "left_column": "styles-module-scss-module__oviM2W__left_column",
  "listings_header": "styles-module-scss-module__oviM2W__listings_header",
  "manager_container": "styles-module-scss-module__oviM2W__manager_container",
  "new_listings_header": "styles-module-scss-module__oviM2W__new_listings_header",
  "office_image": "styles-module-scss-module__oviM2W__office_image",
});
